export const MFA_ENFORCEMENT = {
  DISABLE: 'skip',
  RECOMMEND: 'recommend',
  ENFORCE: 'force'
};
